const PROXIMA_NOVA_FONT = 'https://use.typekit.net/rlr4crj.css'

const fonts = {
  sans: PROXIMA_NOVA_FONT,
} as const

export default fonts
